export default {
    undoDatapoint: {
        datapoint: {
            name: 'TnS_Undo',
            customData: function (actionSource) { return [actionSource]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map